// removed by extract-text-webpack-plugin
module.exports = {"Container":"CheckboxSwitcher__Container___2gFDa","CheckboxSwitcher":"CheckboxSwitcher__CheckboxSwitcher___rs2e3","CheckboxSwitcherText":"CheckboxSwitcher__CheckboxSwitcherText___zBKUp","Marker":"CheckboxSwitcher__Marker___2BKg_","Enabled":"CheckboxSwitcher__Enabled___3lddp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CheckboxSwitcher/CheckboxSwitcher.scss
// module id = 1475
// module chunks = 0